import { Container } from "@mui/system"
import ReadList from "../components/ReadList"

var user = {}

export default function ReadListPage() {

    return <Container>
        <ReadList/>
    </Container>


}